// @import "~@govbr-ds/core/src/components/header-logo/header-logo";

:host {
  display: block;
}
